import { type FC } from 'react';
import { useTranslation } from 'next-i18next';
import type { TopMarketOutcomeSB } from '@mwl/core-lib';
import { extendAnalyticsData, selectCouponSelectedBetsV2, selectIsCouponQuickBetsV2, useSportUrlParams } from '@mwl/core-lib';
import type { OutcomeButtonBaseOldClasses } from '@mwl/ui';
import { Button } from '@/components/Button/Button';
import { OutcomeButton } from '@/components/OutcomeButton/OutcomeButton';
import { useAliasedOutcomes, useTypedSelector } from '@/hooks';
import { checkOutcomesGroups } from '@/utils';
import type { LineRowOddsProps } from '@/types';
import styles from './LineRowOddsCyber.module.scss';
const LineRowOddsCyber: FC<LineRowOddsProps> = ({
  markets,
  lineId,
  linePaused = false,
  lineHref,
  classes,
  analytics,
  lineStage,
  isMatchEnded
}) => {
  const {
    t
  } = useTranslation('sport');
  const oddClasses: OutcomeButtonBaseOldClasses = {
    empty: cn(styles.oddEmpty, classes?.empty),
    active: cn(styles.oddActive, classes?.active),
    title: cn(styles.oddTitle, classes?.title),
    value: cn(styles.oddValue, classes?.value),
    increase: cn(styles.oddIncrease, classes?.increase),
    decrease: cn(styles.oddDecrease, classes?.decrease)
  };
  const selectedBets = useTypedSelector(selectCouponSelectedBetsV2);
  const isQuickBets = useTypedSelector(selectIsCouponQuickBetsV2);
  const aliasedOutcomesGroups = useAliasedOutcomes(markets, 'cyber');
  const {
    sportId
  } = useSportUrlParams();
  const showMoreBetsButton = checkOutcomesGroups(aliasedOutcomesGroups) && !isMatchEnded;
  return <div className={cn(styles.root, {
    [styles.showMoreBets]: showMoreBetsButton,
    [styles.sidebarOpened]: !!sportId
  })} data-sentry-component="LineRowOddsCyber" data-sentry-source-file="LineRowOddsCyber.tsx">
      {aliasedOutcomesGroups?.map(outcomesGroup => <div className={styles.outcomesGroup} key={outcomesGroup.map(({
      id
    }) => id).join('_')}>
          {isMatchEnded && outcomesGroup.map((_, idx) => <div className={styles.ended} key={`${idx}_${idx}`}>
                --
              </div>)}
          {!isMatchEnded && outcomesGroup?.map((outcome, idx) => {
        const isSelected = isQuickBets ? false : !!selectedBets.find(bet => bet.outcomeId === outcome?.id);
        const odds = 'odds' in outcome ? outcome?.odds : '';
        const currentAnalytica = isSelected ? analytics?.sportLinesOddUnSelect : analytics?.sportLinesOddSelect;
        return <OutcomeButton key={outcome?.id ?? idx} lineId={lineId} lineStage={lineStage} outcome={(outcome as TopMarketOutcomeSB) ?? null} variant="horizontal" className={cn(styles.outcomeButton, currentAnalytica?.click?.data?.cls)} isFrozen={(outcome as TopMarketOutcomeSB)?.status === 'PAUSED' || linePaused} classes={oddClasses} analytics={extendAnalyticsData(currentAnalytica, {
          text: odds,
          line_id: lineId,
          outcomes_id: outcome?.id,
          odds
        })} animationTimeout={1000} />;
      })}
        </div>)}
      {showMoreBetsButton && <Button as="link" href={lineHref} variant="filled" fullWidth fontWeight="bold" rounded cut={false} color="grey" className={styles.oddsEmpty}>
          {t('more_bets', 'More Bets')}
        </Button>}
    </div>;
};
export { LineRowOddsCyber };